module.exports = __webpack_public_path__ + "static/customerbg2_mobile-de443954b2a888bf710be8d731068834.png";